module.exports = __webpack_public_path__ + "static/media/project_design_1.6975e5d8.webp";